module.exports = __webpack_public_path__ + "static/media/reporting.084d0d44.svg";